import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { SortableContainer } from 'react-sortable-hoc';
import ListItem from './ListItem';
import i18n from '../../../../internationalization/i18n';

const propTypes = {
  itemsList: PropTypes.array.isRequired,
  selectedItemId: PropTypes.number,
  filterByName: PropTypes.string.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  onClickEditItem: PropTypes.func.isRequired,
  onClickRemoveItem: PropTypes.func.isRequired,
  onSortEnd: PropTypes.func.isRequired,
  onClickPublish: PropTypes.func.isRequired,
  onChangeFilterByName: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedItemId: null,
};

const SortableList = SortableContainer(
  ({ items, selectedItemId, onClickPublish, onSelectItem, onClickEditItem, onClickRemoveItem }) => (
    <div className="c-bb-table__wrapper">
      {items.map((item, index) => (
        <ListItem
          key={`item-${item.id}`}
          index={index}
          label={item.title}
          published={item.route.publishable && item.route.published}
          publishable={item.route.publishable}
          isSelected={selectedItemId === item.id}
          onClickPublish={checked => onClickPublish(item.route.id, checked)}
          onClickEditItem={() => {
            onSelectItem(item.id).then(onClickEditItem);
          }}
          onClickRemoveItem={() => {
            onSelectItem(item.id).then(onClickRemoveItem);
          }}
          createdOn={new Date(item.created_on).toLocaleDateString()}
          updatedOn={new Date(item.updated_on).toLocaleDateString()}
        />
      ))}
    </div>
  ),
);

const BaseModuleItemsList = ({
  itemsList,
  filterByName,
  onSortEnd,
  selectedItemId,
  onClickPublish,
  onSelectItem,
  onClickEditItem,
  onClickRemoveItem,
  onChangeFilterByName,
}) => (
  <div className="c-bb-basemodule-items-list">
    <div className="c-bb-table c-bb-table--basemodules items-list-container">
      <div className="c-bb-table__tr c-bb-table__th c-bb-table__th_colored">
        <div className="c-bb-table__td items-list__drag-icon-td">
          <i className="icon-search" />
        </div>
        <div className="c-bb-table__td items-list__label">
          <input
            className="items-list__search"
            placeholder={i18n.t('BASE_MODULE.searchByName').toUpperCase()}
            type="text"
            value={filterByName}
            onChange={onChangeFilterByName}
          />
        </div>
        <div className="c-bb-table__td c-bb-table__td_center">{i18n.t('BASE_MODULE.createdOn').toUpperCase()}</div>
        <div className="c-bb-table__td c-bb-table__td_center">{i18n.t('BASE_MODULE.modifiedOn').toUpperCase()}</div>
        <div className="c-bb-table__td c-bb-table__td_center items-list__published-td">{i18n.t('CONTENT.publish').toUpperCase()}</div>
        <div className="c-bb-table__td c-bb-table__td--actions">&nbsp;</div>
      </div>
      <SortableList
        useDragHandle
        items={itemsList}
        selectedItemId={selectedItemId}
        onSortEnd={onSortEnd}
        onClickPublish={onClickPublish}
        onSelectItem={onSelectItem}
        onClickEditItem={onClickEditItem}
        onClickRemoveItem={onClickRemoveItem}
      />
    </div>
  </div>
);

BaseModuleItemsList.propTypes = propTypes;
BaseModuleItemsList.defaultProps = defaultProps;

export default withNamespaces()(BaseModuleItemsList);



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleItems/BaseModuleItemsList/BaseModuleItemsList.js